import { render, staticRenderFns } from "./channel.vue?vue&type=template&id=1a9c0740&"
import script from "./channel.vue?vue&type=script&lang=js&"
export * from "./channel.vue?vue&type=script&lang=js&"
import style0 from "./channel.vue?vue&type=style&index=0&id=1a9c0740&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xcll/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a9c0740')) {
      api.createRecord('1a9c0740', component.options)
    } else {
      api.reload('1a9c0740', component.options)
    }
    module.hot.accept("./channel.vue?vue&type=template&id=1a9c0740&", function () {
      api.rerender('1a9c0740', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/superAdmin/authority/components/channel.vue"
export default component.exports